export default "__VITE_ASSET__BldKh7X6__"